// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-orange[data-v-0b456875] {\n  color: orange;\n}\n[dir] .selected[data-v-0b456875] {\n  background: lightgray;\n}\n.noselect[data-v-0b456875] {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n[dir] .content-row[data-v-0b456875]:hover {\n  background-color: lightgray;\n}\n.text-gray[data-v-0b456875] {\n  color: #aaa !important;\n}", ""]);
// Exports
module.exports = exports;
